import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/images/cod-logo.png'
import _imports_1 from '@/app/ui/assets/images/dfod-logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-b474a7a6")

_pushScopeId("data-v-b474a7a6")
const _hoisted_1 = { class: "w-full tracking-height overflow-y-auto pb-8 relative" }
const _hoisted_2 = { class: "mt-8 flex flex-col justify-start gap-1 lg:gap-0 lg:flex-row lg:justify-between lg:items-center" }
const _hoisted_3 = { class: "flex flex-row items-center gap-x-3" }
const _hoisted_4 = { class: "w-full sm:w-350px" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "max-w-none w-16",
  alt: "cod-logo"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "max-w-none w-16",
  alt: "dfod-logo"
}
const _hoisted_7 = {
  key: 0,
  class: "flex flex-row items-center gap-x-3"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "empty-state h-full"
}
const _hoisted_11 = {
  key: 2,
  class: "w-full flex flex-col pt-8"
}
const _hoisted_12 = {
  key: 3,
  class: "flex flex-col mt-8 gap-y-5"
}
const _hoisted_13 = { class: "\n          border border-gray-lp-400\n          shadow-sm\n          rounded-xl\n          py-5\n          px-4\n          overflow-y-auto\n        " }
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = { class: "flex justify-between pb-8" }
const _hoisted_16 = { class: "col-span-2 text-black-lp-300 text-20px font-semibold" }
const _hoisted_17 = { class: "grid grid-cols-2 gap-y-5 w-full" }
const _hoisted_18 = { class: "col-span-2 w-full overflow-x-auto" }
const _hoisted_19 = { class: "text-black-lp-300 table table-min-width" }
const _hoisted_20 = {
  key: 0,
  class: "border border-gray-lp-400 shadow-sm rounded-xl px-5 overflow-y-auto overflow-x-hidden"
}
const _hoisted_21 = { class: "col-span-2 text-black-lp-300 text-20px font-semibold mt-5" }
const _hoisted_22 = { class: "w-full overflow-x-auto" }
const _hoisted_23 = { class: "table-min-width" }
const _hoisted_24 = {
  key: 4,
  class: "flex flex-row gap-x-3 absolute border border-gray-lp-400 shadow-md p-4 rounded-md items-start bg-white",
  style: {"top":"6rem","right":"2px"}
}
const _hoisted_25 = { class: "flex flex-col gap-y-2 text-12px xxl:text-14px max-w-xs" }
const _hoisted_26 = { class: "text-black-lp-300 font-semibold" }
const _hoisted_27 = { class: "text-gray-lp-600" }
const _hoisted_28 = { class: "hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Book = _resolveComponent("Book")!
  const _component_PreviewImage = _resolveComponent("PreviewImage")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_lp_input, {
              placeholder: _ctx.$t('placeholderSTTColumn'),
              modelValue: _ctx.sttNo,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sttNo = $event)),
              onChange: _ctx.handleError,
              onEnter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trackStt(_ctx.sttNo))),
              error: _ctx.isError,
              disabled: false,
              errorIcon: false,
              format: _ctx.formatStt
            }, null, 8, ["placeholder", "modelValue", "onChange", "error", "format"])
          ]),
          _createVNode(_component_lp_button, {
            disabled: !_ctx.sttNo,
            title: _ctx.$t('trackingCargo.buttonTracking'),
            textColor: "white",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trackStt(_ctx.sttNo)))
          }, null, 8, ["disabled", "title"]),
          (_ctx.sttDetail.sttIsCod && !_ctx.sttDetail.sttIsDfod)
            ? (_openBlock(), _createBlock("img", _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.sttDetail.sttIsCod && _ctx.sttDetail.sttIsDfod)
            ? (_openBlock(), _createBlock("img", _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.isSenderAccount)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              (_ctx.dataProfile && !_ctx.accountIsForeign)
                ? (_openBlock(), _createBlock(_component_lp_button, {
                    key: 0,
                    title: _ctx.$t('trackDelivery.reportIssue'),
                    textColor: "white",
                    onClick: _ctx.toCreatePusatResolusi,
                    disabled: !_ctx.showSttDetail
                  }, null, 8, ["title", "onClick", "disabled"]))
                : _createCommentVNode("", true),
              _createVNode(_component_lp_button, {
                disabled: !_ctx.showSttDetail,
                outline: "",
                onClick: _ctx.togglePanelPrint,
                title: _ctx.$t('trackingCargo.buttonPrintReceipt'),
                "text-color": "red-lp-100",
                icon: 
            _ctx.isPanelPrintVisible
              ? `chevron-up-${_ctx.showSttDetail ? 'red' : 'disable'}`
              : `chevron-down-${_ctx.showSttDetail ? 'red' : 'disable'}`
          
              }, null, 8, ["disabled", "onClick", "title", "icon"]),
              _createVNode(_component_OverlayPanel, {
                ref: "panelPrint",
                appendTo: "body",
                style: {"width":"auto"}
              }, {
                default: _withId(() => [
                  _createVNode(_component_LpButton, {
                    onClick: _cache[4] || (_cache[4] = 
              event => {
                _ctx.print('thermal');
                _ctx.togglePanelPrint(event);
              }
            ),
                    class: "w-60",
                    flat: "",
                    dense: "",
                    iconLeft: "printer",
                    title: "Print Thermal Resi"
                  }),
                  _hoisted_8,
                  _createVNode(_component_LpButton, {
                    onClick: _cache[5] || (_cache[5] = 
              event => {
                _ctx.print('thermal-pdf');
                _ctx.togglePanelPrint(event);
              }
            ),
                    class: "w-60",
                    flat: "",
                    dense: "",
                    iconLeft: "document-download-outline-grey",
                    title: "Print Thermal Resi PDF v1"
                  }),
                  _hoisted_9,
                  _createVNode(_component_LpButton, {
                    onClick: _cache[6] || (_cache[6] = 
              event => {
                _ctx.print('basic');
                _ctx.togglePanelPrint(event);
              }
            ),
                    class: "w-60",
                    flat: "",
                    dense: "",
                    iconLeft: "document-download-outline-grey",
                    title: "Print Basic/Save to PDF"
                  })
                ]),
                _: 1
              }, 512)
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isLoading && !_ctx.showSttDetail && !_ctx.isError)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _createVNode(_component_EmptyState, {
              customHeaderMessage: _ctx.errorHedearMessage,
              data: _ctx.messageEmptyState
            }, null, 8, ["customHeaderMessage", "data"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLoading && _ctx.isError)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 1,
            errorType: _ctx.errorCause,
            errorImage: _ctx.alertMessage.image,
            errorTitle: _ctx.alertMessage.title,
            errorMessage: _ctx.alertMessage.message
          }, null, 8, ["errorType", "errorImage", "errorTitle", "errorMessage"]))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode(_component_skeleton, {
              width: "600px",
              height: "40px"
            }),
            _createVNode(_component_skeleton, {
              class: "mt-10",
              width: "800px",
              height: "40px"
            }),
            _createVNode(_component_skeleton, {
              class: "mt-3",
              width: "700px",
              height: "20px"
            }),
            _createVNode(_component_skeleton, {
              class: "mt-3",
              width: "500px",
              height: "20px"
            }),
            _createVNode(_component_skeleton, {
              class: "mt-3",
              width: "800px",
              height: "20px"
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.showSttDetail && !_ctx.isLoading && !_ctx.isError)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("trackingCargo.sttDetailTitle")), 1),
                  (_ctx.showButtonDetailTracking)
                    ? (_openBlock(), _createBlock(_component_LpButton, {
                        key: 0,
                        custom: "px-4 py-3 bg-red-lp-200 font-normal",
                        title: _ctx.$t('trackingCargo.buttonShowDetailStt'),
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (
                _ctx.goToDetailShipment(_ctx.isConsole, _ctx.isSubConsole, _ctx.sttDetail.sttId)
              )),
                        textColor: "white",
                        iconLeft: "eye",
                        iconV2: ""
                      }, null, 8, ["title"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _createVNode("div", _hoisted_19, [
                      _createVNode(_component_TableV2, {
                        style: {"margin-top":"0"},
                        columns: _ctx.columns,
                        data: _ctx.sttDetailTable,
                        pagination: _ctx.pagination,
                        hidePagination: ""
                      }, null, 8, ["columns", "data", "pagination"])
                    ])
                  ]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('trackingCargo.sttDetailInfo.detailShipperName'),
                    value: _ctx.sttDetail.senderName,
                    class: "pl-4"
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('trackingCargo.sttDetailInfo.detailRecipientName'),
                    value: _ctx.sttDetail.recipientName,
                    class: "pl-4"
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_DataWrapper, {
                    label: 
                _ctx.$t('trackingCargo.sttDetailInfo.detailDistrictOriginCity')
              ,
                    value: _ctx.sttDetail.originLocation,
                    class: "pl-4"
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_DataWrapper, {
                    label: 
                _ctx.$t('trackingCargo.sttDetailInfo.detailDistrictDestinationCity')
              ,
                    value: _ctx.sttDetail.destinationLocation,
                    class: "pl-4"
                  }, null, 8, ["label", "value"])
                ])
              ])
            ]),
            (_ctx.showSttDetail && !_ctx.isLoading && !_ctx.isError)
              ? (_openBlock(), _createBlock("div", _hoisted_20, [
                  (!_ctx.IS_REVERSE_JOURNEY)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("trackingCargo.sttHistoryTitle")), 1),
                        _createVNode("div", _hoisted_22, [
                          _createVNode("div", _hoisted_23, [
                            _createVNode(_component_TableV2, {
                              style: {"margin-top":"0"},
                              columns: _ctx.columnsHistory,
                              data: _ctx.shipmentHistory,
                              pagination: _ctx.pagination,
                              hidePagination: "",
                              borderTop: false,
                              borderBottom: false,
                              loading: _ctx.isSecondLoading
                            }, null, 8, ["columns", "data", "pagination", "loading"])
                          ])
                        ])
                      ], 64))
                    : (_openBlock(), _createBlock(_component_Tabs, {
                        key: 1,
                        modelValue: _ctx.activeMenu,
                        onChange: _ctx.onChangeHistoryTabs,
                        data: _ctx.tabs,
                        rounded: false,
                        titleSize: 16
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_TableV2, {
                            style: {"margin-top":"0"},
                            columns: _ctx.columnsHistory,
                            data: _ctx.shipmentHistory,
                            pagination: _ctx.pagination,
                            hidePagination: "",
                            borderTop: false,
                            borderBottom: false,
                            loading: _ctx.isSecondLoading
                          }, null, 8, ["columns", "data", "pagination", "loading"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange", "data"]))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowAlertMessage)
        ? (_openBlock(), _createBlock("div", _hoisted_24, [
            _createVNode("img", {
              src: require('@/app/ui/assets/svg/exclamation-yellow.svg'),
              class: "w-6 max-w-none",
              alt: "warning"
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_25, [
              _createVNode("p", _hoisted_26, _toDisplayString(_ctx.alertMessage.title), 1),
              _withDirectives(_createVNode("p", _hoisted_27, null, 512), [
                [_directive_sanitize_html, _ctx.alertMessage.message]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_28, [
      _createVNode(_component_Book, { ref: "book" }, null, 512)
    ]),
    (_ctx.showPreviewImage)
      ? (_openBlock(), _createBlock(_component_PreviewImage, {
          key: 0,
          onClose: () => _ctx.actionModalPreview(false),
          data: _ctx.images
        }, null, 8, ["onClose", "data"]))
      : _createCommentVNode("", true)
  ], 64))
})